import React, { useContext, useState } from 'react';
import { Item, Button, Label, Segment, Table, Menu, Icon, Confirm, Container, Tab, Grid, GridColumn, Form, Input, Dropdown, Select } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import BogStore from '../../../app/stores/bogStore';
import { Link } from 'react-router-dom';

const BogListByTechnician: React.FC = () => {
  const bogStore = useContext(BogStore);
  const {bogList, bogsByDate, searchTechnician, selectBogTitle, bogSearchList, submitting, target} = bogStore;

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [technician, setTechnician] = useState("");
  const [required, setRequired] = useState(false);

  const technicianList  = bogList.map((item) => {
    return item["technician"];
  });
  const technicians = technicianList.filter(function(item, pos) {
    return technicianList.indexOf(item) == pos;
  })
  const technicianOptions = technicians.map(function (tech) {
    var option = { "key": tech, "text": tech, "value": tech }
    return option;
  }
  );

  const projectList  = bogSearchList.map((item) => {
    return item["projectType"];
  });
  const projects = projectList.filter(function(item, pos) {
    return projectList.indexOf(item) == pos;
  })
  projects.unshift('ALL');

  const companyList  = bogSearchList.map((item) => {
    return item["company"];
  });
  const companys = companyList.filter(function(item, pos) {
    return companyList.indexOf(item) == pos;
  })
  companys.unshift('ALL');

  function getDayOfWeek(date: string) {
    const dayOfWeek = new Date(date).getDay();    
    return isNaN(dayOfWeek) ? null : 
      ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayOfWeek];
  }

  function convertDate(date: string) {
    var arrDate = date.split("-");
    return arrDate[2] + "/" +arrDate[1] + "/" + arrDate[0];
  } 

  const handleSubmit = () => {
    if (technician !== "")
    {
      searchTechnician(technician, startDate, endDate);
    }
    else
    {
      setRequired(true);
    }
  };

  return (
    <Container fluid>
      <br/>
      <Form onSubmit={handleSubmit}>
      <Grid>
      <GridColumn width='5'>
          <Form.Field inline>
           <label>Technician: </label>
           <Select
          required
          onChange={(e, { value }) => {setTechnician(String(value));setRequired(false)}}
          options={technicianOptions}
          search
          name='technician'
          placeholder='Technician Name'
          value={technician}
        />
        {(required) && <p style={{color: 'red'}}>please select technician</p>}
          </Form.Field>
        </GridColumn>
        <GridColumn width='4'>
          <Form.Field inline>
           <label>From: </label>
           <Input
             onChange={(e, {value}) => setStartDate(value)}
             name="startDate"
             placeholder="Start Date"
             value={startDate}
             type="date"
           />
           <p>leave blank to display all dates</p>
          </Form.Field>
        </GridColumn>
        <GridColumn width='4'>
          <Form.Field inline>
           <label>To: </label>
           <Input 
             onChange={(e, {value}) => setEndDate(value)}
             name="endDate"
             placeholder="End Date"
             value={endDate}
             type="date"
           />
           <p>leave blank to display all since start date</p>
          </Form.Field>
        </GridColumn>
        <GridColumn width='3' textAlign='center'>
        <Form.Button
          size='small'
          positive
          content='Submit'
          type='submit'
        />
        </GridColumn>
      </Grid>
      </Form>
      <br/>
      <Table celled>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Technician</Table.HeaderCell>
        <Table.HeaderCell>Date</Table.HeaderCell>       
        <Table.HeaderCell>
        <Dropdown text='Project Type'>
        <Dropdown.Menu>
          <Dropdown.Header ><span style={{color: 'grey'}}>Choose from below</span></Dropdown.Header>
          <Dropdown.Divider/>
        {projects.map((project) => 
           <Dropdown.Item
             name='projectType'
             onClick={(e, { name }) =>
             selectBogTitle(name, project)
            }
           >
             {project}
           </Dropdown.Item>)}
          </Dropdown.Menu>
        </Dropdown>
        </Table.HeaderCell>
        <Table.HeaderCell>
        <Dropdown text='Company'>
        <Dropdown.Menu>
          <Dropdown.Header ><span style={{color: 'grey'}}>Choose from below</span></Dropdown.Header>
          <Dropdown.Divider/>
        {companys.map((company) => 
           <Dropdown.Item
             name='company'
             onClick={(e, { name }) =>
             selectBogTitle(name, company)
            }
           >
             {company}
           </Dropdown.Item>)}
          </Dropdown.Menu>
        </Dropdown>
        </Table.HeaderCell>
        <Table.HeaderCell>Site ID</Table.HeaderCell>
        <Table.HeaderCell>Site Name</Table.HeaderCell>
        <Table.HeaderCell>State</Table.HeaderCell>
        <Table.HeaderCell>Ring ID</Table.HeaderCell>
        <Table.HeaderCell>Work Type</Table.HeaderCell>
        <Table.HeaderCell>Status</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
    {bogsByDate.map(bog => (     
      <Table.Row>
        <Table.Cell><strong>{bog.technician}</strong></Table.Cell>  
        <Table.Cell>
         {convertDate(bog.date)}
         <p>{getDayOfWeek(bog.date)}</p>
        </Table.Cell>    
        <Table.Cell>{bog.projectType}</Table.Cell>
        <Table.Cell>{bog.company}</Table.Cell>
        <Table.Cell>{bog.siteId}</Table.Cell>
        <Table.Cell>{bog.siteName}</Table.Cell>
        <Table.Cell>{bog.state}</Table.Cell>
        <Table.Cell>{bog.ringId}</Table.Cell>
        <Table.Cell>{bog.type}</Table.Cell>
        <Table.Cell>{bog.status}</Table.Cell>       
      </Table.Row>
    ))}
    </Table.Body>
  </Table>
    </Container>
  );
};

export default observer(BogListByTechnician);
